import React from "react"
import { TableOrder } from "@/types/orders.types"
import { faCopy } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography } from "antd"
import { capitalize } from "lodash"
import CancelOrderModal from "@/UI/Modals/CancelOrdersModal/CancelOrdersModal"
import OrderAgainButton from "@/modules/active-orders/shared/OrderAgainButton"
import CancelStopsModal from "@/UI/Modals/CancelStopsModal/CancelStopsModal"
import BulkStopsReorder from "@/modules/active-orders/ActiveOrdersFiltersAndActions/TableStopsActions/components/BulkStopsReorder"
import { Stop } from "@/types/stops.types"
import AddTipModal from "@/modules/active-orders/OrderTable/components/AddTipModal"

interface OrderDetailsModalTitleProps {
  order: TableOrder
  selectedStop?: Stop
  isViewOnly?: boolean
  isStop?: boolean
  title?: string
  isCancelled: boolean
  isCancellable: boolean
  isOrderAgainDisabled: boolean
  statusTag: React.ReactElement
  cancelStopCallback?: () => Promise<void>
}

const { Title } = Typography
const OrderDetailsModalTitle: React.FC<OrderDetailsModalTitleProps> = ({
  order,
  selectedStop,
  isViewOnly,
  title,
  isCancellable,
  isCancelled,
  isOrderAgainDisabled,
  statusTag,
  cancelStopCallback,
}) => {
  return (
    <div className="flex w-[95%]  flex-wrap items-center justify-between">
      <div className="flex space-x-5 items-center">
        <Title
          className="!m-0"
          copyable={{
            text: title,
            icon: <FontAwesomeIcon icon={faCopy} fontSize={12} className="!text-kosmoGray" />,
          }}
          level={4}
        >
          {title}
        </Title>
        {/* Status tag passed as prop */}
        {statusTag}
        {isCancelled && !!order?.cancelReason && (
          <p className="m-0 text-gray-500">{capitalize(order?.cancelReason)}</p>
        )}
      </div>
      {!isViewOnly && (
        <div className="flex gap-x-4 w-fit flex-wrap gap-y-2 ">
          <AddTipModal
            order={order}
            currencyCode={order?.currency}
            deliveryId={order?.id}
            currentTip={order?.priceBreakdown?.tips}
          />
          {selectedStop ? (
            <>
              <CancelStopsModal stops={[selectedStop]} callback={cancelStopCallback} />
              <BulkStopsReorder stops={[selectedStop]} withRedirect={false} />
            </>
          ) : (
            <>
              {isCancellable && <CancelOrderModal orders={[order]} />}
              {!isOrderAgainDisabled && <OrderAgainButton order={order} />}
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default OrderDetailsModalTitle
